export default {"src":"/login-app/[GIT_HASH]/_next/static/media/freshness.5e75298a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};